import { useLocation, useParams } from 'react-router';
import { Redirect } from 'react-router-dom';

export const EditAutomationTemplateWithAppDrawer = () => {
	const location = useLocation();
	const { id } = useParams<{ id: string }>();

	if (!id) {
		return null;
	}

	return (
		<Redirect
			to={{
				pathname: `/automations/${id}/canvas`,
				search: location.search,
				hash: location.hash,
				state: location.state,
			}}
		/>
	);
};
